import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal, Grid, Button } from 'semantic-ui-react';
import { AppState } from 'services/types';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

// Global Components
import ErrorAlert from 'components/ErrorAlert';
// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';

// Actions
import { updateQueryString } from 'services/router/actions';
import { requestDeleteSprayEvent } from 'services/sprayEvents/actions';

// Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

import { SprayEventUuid } from 'services/sprayEvents/types';
import DeleteSprayEventModalMessage from './components/DeleteSprayEventModalMessage';
import { makeSelectSelectedIncompleteSprayEventsUuids } from '../SprayEventsVirtualizedTable/selectors';

// Constants
const NAMESPACE = 'SPRAY_EVENT_DELETE';
export const DELETE_SPRAY_EVENT_MODAL = 'deleteSprayEventModal';

interface ConnectedProps {
    deleteSprayEventModal: boolean;
    uuids: SprayEventUuid[];
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
    requestDeleteSprayEvent: typeof requestDeleteSprayEvent;
}

type Props = ConnectedProps & DispatchProps;

export class DeleteSprayEventModal extends React.PureComponent<Props> {
    get open(): boolean {
        const { deleteSprayEventModal, uuids } = this.props;
        return !!deleteSprayEventModal && !!uuids;
    }

    handleClose = (): void => {
        this.props.updateQueryString({
            deleteSprayEventModal: undefined,
            selectedEventId: undefined
        });
    };

    handleDeleteSprayEvent = (): void => {
        const { uuids } = this.props;

        this.props.requestDeleteSprayEvent(uuids);
    };

    render(): React.ReactElement {
        const { uuids } = this.props;

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={this.open}
                    onClose={this.handleClose}
                    size="tiny"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="exportTimesheetsModal"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>
                            Delete Spray {uuids.length > 1 ? 'Events' : 'Event'}
                        </Modal.Header>
                        <Modal.Content>
                            <DeleteSprayEventModalMessage uuids={uuids} />
                            <ErrorAlert namespace={NAMESPACE} />
                            <Grid>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <Button
                                        type="button"
                                        onClick={this.handleClose}
                                        fluid
                                        basic
                                        primary
                                    >
                                        Cancel
                                    </Button>
                                </Grid.Column>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <SubmittingButton
                                        type="button"
                                        namespace={NAMESPACE}
                                        negative
                                        fluid
                                        onClick={this.handleDeleteSprayEvent}
                                    >
                                        Delete
                                    </SubmittingButton>
                                </Grid.Column>
                            </Grid>
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    deleteSprayEventModal: makeSelectQueryStringValue(DELETE_SPRAY_EVENT_MODAL),
    uuids: makeSelectSelectedIncompleteSprayEventsUuids()
});

export default connect(mapStateToProps, {
    updateQueryString,
    requestDeleteSprayEvent
})(DeleteSprayEventModal);
